/* eslint-disable no-use-before-define */
/* eslint-disable import/prefer-default-export */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */

import { useMemo, useState, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import {
  getInterfacePriority,
  resetBoxToDefaultAction,
  setInterfacePriorityState,
} from '../../../../../../../actions/EpikBoxes';
import { useRefreshBox } from '../../../../../../../hooks';
import utils from '../../../../../../../lib/utils';
import {
  EResetBoxToDefaultActions,
  ERROR_MESSAGES,
  REST_BOX_TO_DEFAULT_VALIDATION_CHECK,
  defaultHandlerState,
} from '../../constants';

export const useResetToDefault = ({ resetNotesType, setResetNotesType, setResetBoxResult }) => {
  const [handlerState, setHandlerState] = useState(defaultHandlerState);
  const { modalType } = handlerState;

  const [resetInputVal, setResetInputVal] = useState('');

  const { current: token } = useRef(utils.getAuthToken());

  const dispatch = useDispatch();

  const { _id: boxID, vpnAddress } = useSelector(state => state.AppState.boxDetails.box);
  const interfacePriority = useSelector(state => state.UIState.epikBoxes.interfacePriority);

  const { refreshBoxData } = useRefreshBox(boxID);

  const resetBoxToDefaultAction_ = () =>
    dispatch(resetBoxToDefaultAction(boxID, resetNotesType, utils.getAuthToken()));

  const setInterfacePriorityState_ = data => dispatch(setInterfacePriorityState(data));

  const getInterfacePriority_ = () => dispatch(getInterfacePriority(token, vpnAddress));

  const handleResetInputChange = useCallback(e => {
    e.preventDefault();
    const { value } = e.target;
    setResetInputVal(value);
  }, []);

  const showValidationToastError = () =>
    toast.error(ERROR_MESSAGES.PLEASE_ENTER_DEFAULT_TO_PROCEED);

  const setResetInputValToEmptyValue = () => setResetInputVal('');

  const openSecurityModalAndCloseWarningModal = () =>
    setHandlerState(() => ({
      showWarningModalForReset: false,
      showSecurityModal: true,
      modalType: EResetBoxToDefaultActions.DEFAULT_WARNING_MODAL,
    }));

  const showStepOneWarningModal = () =>
    setHandlerState(prev => ({
      ...prev,
      showWarningModalForReset: true,
      modalType: EResetBoxToDefaultActions.DEFAULT_WARNING_MODAL,
    }));

  const hideAndResetWarningModalToDefaultType = () => {
    setResetNotesType('');
    setHandlerState(prev => ({
      ...prev,
      showWarningModalForReset: false,
      modalType: EResetBoxToDefaultActions.DEFAULT_WARNING_MODAL,
    }));
  };

  const switchToStepTwoModal = () => {
    setHandlerState(prev => ({
      ...prev,
      modalType: EResetBoxToDefaultActions.WARNING_MODAL_WITH_INPUT,
    }));
    setResetInputValToEmptyValue();
  };

  const closeSecurityModalAndResetState = () => setHandlerState(defaultHandlerState);

  const isModalTypeOnStepTwo = useMemo(
    () => modalType === EResetBoxToDefaultActions.WARNING_MODAL_WITH_INPUT,
    [modalType],
  );

  const validateFieldsInStepTwoModal = () => {
    if (resetInputVal !== REST_BOX_TO_DEFAULT_VALIDATION_CHECK.DEFAULT) {
      showValidationToastError();
      return;
    }
    openSecurityModalAndCloseWarningModal();
  };

  const onWarningModalConfirm = useCallback(
    e => {
      e.preventDefault();
      switch (modalType) {
        case EResetBoxToDefaultActions.DEFAULT_WARNING_MODAL:
          switchToStepTwoModal();
          break;
        case EResetBoxToDefaultActions.WARNING_MODAL_WITH_INPUT:
          validateFieldsInStepTwoModal();
          break;
        default:
          break;
      }
    },
    [modalType, resetInputVal],
  );

  const fetchPriorityAndUpdateToggle = useCallback(async () => {
    const data = await getInterfacePriority_(token, vpnAddress);
    setInterfacePriorityState_(data);
  }, [vpnAddress]);

  const changeBoxOptionsAndRefreshBox = useCallback(async () => {
    fetchPriorityAndUpdateToggle();
    refreshBoxData();
    setResetBoxResult(null);
  }, [boxID, vpnAddress]);

  const securityModalOnConfirm = useCallback(async () => {
    closeSecurityModalAndResetState();
    const res = await resetBoxToDefaultAction_();
    if (!res) return;
    setResetBoxResult(res);
  }, [resetInputVal, boxID, vpnAddress]);

  return {
    handlerState,
    resetInputVal,
    switchToStepTwoModal,
    isModalTypeOnStepTwo,
    onWarningModalConfirm,
    handleResetInputChange,
    securityModalOnConfirm,
    showStepOneWarningModal,
    validateFieldsInStepTwoModal,
    closeSecurityModalAndResetState,
    hideAndResetWarningModalToDefaultType,
    changeBoxOptionsAndRefreshBox,
  };
};
